export class UpgradeEvent {
    event: string = 'upgrade';
    travelClass: string;

    constructor(travelClass: string) {
        this.travelClass = travelClass;
    }
}